import React from 'react';
import { HashRouter, Route } from 'react-router-dom';
import {checkIfTokenIsPresent} from '../../helper';
import Navbar from '../../components/Navbar';
import Navigation from '.././Navigation';
import Modal from '../../components/Modal';
import Feedback from './Feedback/Feedback';
import Oppurtunities from './Opportunities';
import RebateData from './RebateData';
import TerminatedVPOpportunity from './ConversionOpportunity';
import Overview from './Overview';
import FBIRebate from './FBIRebate';
import Compliance from './Compliance'

class Corporate extends React.Component {

    state = {
        displayModal:false,
        propsForModal:{
            icon: "fas fa-exclamation-circle",
            message: "You do not have permission to access this section.",
            type: "error"
        },
        defaultOption:this.props.location.pathname,
        expanded: false,
        defaultOption: "Overview",
        options: [
            { icon: "fas fa-users", title: "Overview", link: "/Overview" },
            { icon: "fas fa-dollar-sign" ,title: "Rebate Data", link: "/RebateData" },
            { icon: "fas fa-table", title: "Opportunities", link: "/Opportunities" },
            { icon: "fas fa-book", title: "Feedback", link: "/Feedback" },
            { icon: "fas fa-user", title: "Conversion Opportunity", link: "/ConversionOpportunity" },
            { icon: "fas fa-user", title: "Supplier FBI Rebate", link: "/FBIRebate" },
            { icon: "fas fa-user", title: "Compliance", link: "/Compliance" },
        ]
    }

    handleSelected = (selected) => {
        if (selected == "Overview") {
            this.props.history.push('/Corporate/Overview')
        }
        else if (selected == "Rebate Data") {
            this.props.history.push('/Corporate/RebateData')
        }
        else if (selected == "Opportunities") {
            this.props.history.push('/Corporate/Opportunities')
        }
        else if (selected == "Feedback") {
            this.props.history.push('/Corporate/Feedback')
        }
        else if (selected == "Conversion Opportunity") {
            this.props.history.push('/Corporate/ConversionOpportunity')
        }
        else if (selected == "Supplier FBI Rebates") {
            this.props.history.push('/Corporate/FBIRebate')
        }
        else if (selected == "Compliance") {
            this.props.history.push('/Corporate/Compliance')
        }
    }

    handleToggle = (expanded) => {
        this.setState({ expanded })
    }
    componentWillMount(){
        if(!checkIfTokenIsPresent()){
            this.props.history.push('/Login');
       }
    }
    componentDidMount(){
        if(checkIfTokenIsPresent()){
            this.checkIfPermittedToAccessMember();
        }else{
           // this.props.history.push('/Login');
        }
        
    }
    checkIfPermittedToAccessMember(){
        let groupId = localStorage.getItem('imark-groupId');
        let userType = localStorage.getItem('imark-userType');
        console.log(userType);
            if( userType==="CORPORATE"){
                this.setState({
                    displayModal:false
                });
            } else{
                this.setState({
                    displayModal:true
                });
            }
    }
    closeModal=()=>{
        this.props.history.push('/');
    }
    render() {
        const {propsForModal} = this.state;
        let modifiedPath = this.props.location.pathname;
        let modifiedPathArr = modifiedPath.split("/");
        modifiedPath = modifiedPathArr[modifiedPathArr.length-1];
        console.log('modified path ',modifiedPath);
       
        if(this.state.displayModal){
            return (
                <div>
               <Navbar isExpanded={this.state.expanded.expanded} />
                <Modal modalType="error" propsForModal={propsForModal} closeModal={this.closeModal} />
                </div>
            )
        }
        return (
            <div>
                <Navigation isExpanded={this.state.expanded.expanded} handleSelected={(selected) => this.handleSelected(selected)} options={this.state.options} defaultOption={modifiedPath}  />
                <HashRouter>
                    <Route exact path="/Corporate/Overview" render={() => <Overview isExpanded={this.state.expanded.expanded} />} />
                    <Route exact path="/Corporate/RebateData" render={() => <RebateData isExpanded={this.state.expanded.expanded} />} />
                    <Route exact path="/Corporate/Opportunities" render={() => <Oppurtunities isExpanded={this.state.expanded.expanded} />} />
                    <Route exact path="/Corporate/Feedback" render={() => <Feedback isExpanded={this.state.expanded.expanded} />} />
                    <Route exact path="/Corporate/ConversionOpportunity" render={() => <TerminatedVPOpportunity isExpanded={this.state.expanded.expanded} />} />
                    <Route exact path="/Corporate/FBIRebate" render={() => <FBIRebate isExpanded={this.state.expanded.expanded} />} />
                    <Route exact path="/Corporate/Compliance" render={() => <Compliance isExpanded={this.state.expanded.expanded} />} />
                </HashRouter>
            </div>
        )

    }
}

export default Corporate;